/**
 *
 * list sagas
 *
 */

import {
    put, call, takeLatest, select,
} from 'redux-saga/effects';
import { LOAD_LIST } from './list-constants';
import { listLoaded, listLoadingError } from './list-actions';
import { makeSelectListEndpoint } from '../config/runtime-config-selectors';
import { makeSelectSearchEndpoint } from '../config/runtime-config-selectors';

import request from 'utils/request';

/**
 * List data request/response handler
 */
export function* getListData(action) {

    const selectionSlug = action.topicId;
    const advancedCriteria = action.advancedCriteria;
    let requestURL;

    if (advancedCriteria) {

        const searchEndpoint = yield select(makeSelectSearchEndpoint());

        //https://www.milb.com/data-service/en/search/?advancedCriteria=%2Fvideos%3Ftags.slug%3Ddefense&limit=100
        requestURL = `${searchEndpoint}?advancedCriteria=${encodeURIComponent(advancedCriteria)}&limit=100`;

    } else {

        const urlTemplate = yield select(makeSelectListEndpoint());

        requestURL = urlTemplate ? urlTemplate.replace('{selectionSlug}', selectionSlug) : '';

    }

    try {

        let list = yield call(request, requestURL);

        if (advancedCriteria) {

            list = {
                items: list.docs,
            };

        }

        yield put(listLoaded(list));


    } catch (error) {

        yield put(listLoadingError(error));

    }

}

/**
 * Root saga manages watcher lifecycle
 */
export default function* listData() {

    // Watches for LOAD_LIST actions and calls getListData when one comes in.
    // By using `takeLatest` only the result of the latest API call is applied.
    // It returns task descriptor (just like fork) so we can continue execution
    // It will be cancelled automatically on component unmount
    yield takeLatest(LOAD_LIST, getListData);

}
